import React from 'react'
import Proptypes from 'prop-types'

import { StyledPrimaryButton } from './PrimaryButton.styles'

const PrimaryButton = props => <StyledPrimaryButton { ...props } />

PrimaryButton.propTypes = {
  onClick: Proptypes.func,
  disabled: Proptypes.bool
}
PrimaryButton.defaultProps = {
  onClick: null,
  disabled: false
}

export default PrimaryButton
